export default (string : string) : boolean => !Number.isNaN(string) && !Number.isNaN(parseFloat(string));
